const searchForPermissions = (type, search, permissions = []) => {
  const newPermissions = [...permissions];
  switch (type) {
    case 'guide': {
      const guideFound =
        newPermissions.find(guide => guide.id === search) || {};
      return Object.keys(guideFound).length ? { ...guideFound } : undefined;
    }
    case 'menu': {
      const menuFound = newPermissions.reduce((obj, guide) => {
        if (guide.items && guide.items.length) {
          const menu = guide.items.find(menu => menu.id === search);
          if (menu) {
            obj = { ...menu };
          }
        }
        return obj;
      }, {});
      return Object.keys(menuFound).length ? { ...menuFound } : undefined;
    }
    case 'submenu': {
      const submenuFound = newPermissions.reduce((obj, guide) => {
        if (guide.items && guide.items.length) {
          const _submenuFound = guide.items.reduce((obj, menu) => {
            if (menu.items && menu.items.length) {
              const submenu = menu.items.find(submenu => {
                return submenu.id === search || submenu.link === search;
              });
              if (submenu) {
                obj = { ...submenu };
              }
            }
            return obj;
          }, {});
          if (_submenuFound) {
            obj = { ..._submenuFound };
          }
        }
        return obj;
      }, {});
      return Object.keys(submenuFound).length ? { ...submenuFound } : undefined;
    }
  }
};

export default searchForPermissions;
